import script from "./ScrollMover.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollMover.vue?vue&type=script&setup=true&lang=js"

import "./ScrollMover.vue?vue&type=style&index=0&id=04ee3fde&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ee3fde"]])

export default __exports__